import React from 'react';
import quiz from './Assets/quiz.svg';
import trophy from './Assets/trophy.svg';
import project from './Assets/project.svg';
import { Link } from 'react-router-dom';

const MenuBox = () => {
  return (
    <div>
      <div className='box-menu'>
        <Link to='/map-quiz'>
          <div className='layer-menu'>
            <img src={quiz} alt='Quiz Icon' className='flag' />
            <span className='sel'>Take the Quiz</span>
          </div>
        </Link>
        <Link to='/leaderboards'>
          <div className='layer-menu'>
            <img src={trophy} alt='India Icon' className='flag' />
            <span className='sel'>Leaderboards</span>
          </div>
        </Link>
        <Link to='/about'>
          <div className='layer-menu'>
            <img src={project} alt='USA Icon' className='flag' />
            <span className='sel'>About</span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MenuBox;
